import { FC } from "react";

import TableAdminUsers from "../../../components/table/accessRights/TableAdminUsers";

import styles from "./adminUsers.module.scss";

const AdminUsers: FC = () => {
  return (
    <div className={styles.wrapper}>
      <TableAdminUsers />
    </div>
  );
};

export default AdminUsers;
